import React from 'react';
import { Link } from 'react-router-dom';

/**
 * SetupGuard — shows a friendly prerequisite warning instead of a broken page.
 *
 * Props:
 *   checks  — array of { ok: bool, icon, label, description, action: { label, to } }
 *   children — rendered only when all checks pass
 */
const SetupGuard = ({ checks = [], children }) => {
  const failing = checks.filter(c => !c.ok);
  if (failing.length === 0) return children;

  return (
    <div style={{
      background: 'var(--card-bg)',
      border: '1px solid #f0c040',
      borderLeft: '5px solid #f0c040',
      borderRadius: 10,
      padding: '1.5rem 1.75rem',
      maxWidth: 640,
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', marginBottom: '1rem' }}>
        <span style={{ fontSize: '1.4rem' }}>⚠️</span>
        <strong style={{ fontSize: '1.05rem' }}>Setup required before continuing</strong>
      </div>
      <p style={{ margin: '0 0 1.25rem', color: 'var(--text-light)', fontSize: '0.92rem' }}>
        The following steps must be completed first:
      </p>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.85rem' }}>
        {failing.map((c, i) => (
          <div key={i} style={{
            background: 'var(--bg-secondary, #f9f9f9)',
            border: '1px solid var(--border-color)',
            borderRadius: 8,
            padding: '0.9rem 1rem',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: '0.75rem',
          }}>
            <div style={{ display: 'flex', gap: '0.75rem', alignItems: 'flex-start' }}>
              <span style={{ fontSize: '1.4rem', flexShrink: 0 }}>{c.icon}</span>
              <div>
                <div style={{ fontWeight: 600, marginBottom: '0.2rem' }}>{c.label}</div>
                {c.description && (
                  <div style={{ fontSize: '0.83rem', color: 'var(--text-light)' }}>{c.description}</div>
                )}
              </div>
            </div>
            {c.action && (
              <Link
                to={c.action.to}
                className="btn btn-primary"
                style={{ fontSize: '0.85rem', padding: '0.35rem 1rem', whiteSpace: 'nowrap' }}
              >
                {c.action.label}
              </Link>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default SetupGuard;
